import { FaUser, FaFile, FaShoppingBasket, FaSortNumericDown, FaPercentage, FaBuilding, FaHome, FaWalking } from 'react-icons/fa';
import { LinkNavegacion } from '../../Utils/LinkNavegacion';

const MenuAdministrativos = () => {

return (
    <div className="card">
        <div className="card-header">
            <h2>Informes Caracterizaci&oacute;n</h2>
        </div>
        <div className="card-body">
            <div className="row">
                <div>
                    <LinkNavegacion enlace={'/caracterizacion/administrativo/personas'} titulo="Personas" icon={FaUser} />
                    <LinkNavegacion enlace={'/caracterizacion/administrativo/familias'} titulo="Familias" icon={FaUser} />
                    <LinkNavegacion enlace={'/caracterizacion/administrativo/ayudas'} titulo="Atenciones" icon={FaShoppingBasket} />                        
                    <LinkNavegacion enlace={'/caracterizacion/administrativo/remisiones'} titulo="Remisiones" icon={FaFile} />
                    <LinkNavegacion enlace={'/caracterizacion/administrativo/beneficiarios'} titulo="Beneficiarios" icon={FaPercentage} />
                    <LinkNavegacion enlace={'/organizaciones/informe/organizaciones'} titulo="Organizaciones" icon={FaBuilding} />
                    <LinkNavegacion enlace={'/caracterizacion/administrativo/estadisticos'} titulo="Estadisticos AHE" icon={FaSortNumericDown} />
                    <LinkNavegacion enlace={'/caracterizacion/administrativo/retornos'} titulo="Estadisticos Retornos" icon={FaWalking} />
                    <LinkNavegacion enlace={'/albergues/informe/alberguesingreso'} titulo="Estadisticos Albergue" icon={FaHome} />
                    <LinkNavegacion enlace={'/caracterizacion/administrativo/atenciones'} titulo="Estadisticos Atenciones" icon={FaShoppingBasket} />
                </div>
            </div>
        </div>
    </div>
);
};

export default MenuAdministrativos;